// Collections desk region (UK | AUS) — module flag mirrored from RegionContext
// by the ageing pages, read by the api interceptor and the money formatters.
let _region = "UK";
export const setCollectionsRegion = (r) => { _region = r === "AUS" ? "AUS" : "UK"; };
export const getCollectionsRegion = () => _region;
export const isAusDesk = () => _region === "AUS";
export const cur = () => (_region === "AUS" ? "$" : "£");
export const ageingBasePath = () => (_region === "AUS" ? "/aus/collections/ageing" : "/collections/ageing");
export const fmtMoney = (v, dp = 0) =>
  new Intl.NumberFormat(_region === "AUS" ? "en-AU" : "en-GB", {
    style: "currency", currency: _region === "AUS" ? "AUD" : "GBP",
    minimumFractionDigits: dp, maximumFractionDigits: dp,
  }).format(Number(v || 0));
export const REGION_LABELS = {
  UK:  { registry: "Companies House", hold: "Breathing Space", regulator: "FCA" },
  AUS: { registry: "ASIC / ABR",      hold: "Hardship hold",   regulator: "ASIC" },
};
export const rl = (key) => REGION_LABELS[_region][key];
